export default __webpack_public_path__ + "static/media/lang_ico.fd64c8c3.svg";